import { Pipe, PipeTransform, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslationService } from 'src/app/service/api/translation.service';
import { TranslationRequest } from '../models/TranslationRequest';

@Pipe({
  name: 'translation',
  pure: false
})
export class TranslationPipe implements PipeTransform, OnDestroy {
  private subscriptions = new Map<string, Subscription>();
  private translationCache = new Map<string, string>();

  constructor(private translationService: TranslationService) {}

  transform(key: string, translationRequest: TranslationRequest = null): string {
    if(sessionStorage.getItem('languagepreference') === null || sessionStorage.getItem('languagepreference') === 'en')
      {
        return key;
      }
    // If we already have a cached translation, return it
    if (this.translationCache.has(key)) {
      return this.translationCache.get(key);
    }

    // If we don't have a subscription for this key, create one
    if (!this.subscriptions.has(key)) {
      const subscription = this.translationService.getTranslationForKey$(key, translationRequest).subscribe(
        (translatedValue) => {
          this.translationCache.set(key, translatedValue);
        }
      );
      this.subscriptions.set(key, subscription);
    }

    // Return current translation from service or fallback to key
    const currentValue = this.translationService.getTranslationForKey(key, translationRequest);
    this.translationCache.set(key, currentValue);
    return currentValue;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
    this.subscriptions.clear();
    this.translationCache.clear();
  }
}
